import React from 'react';
import PropTypes from 'prop-types';
import useCartState from '../../hooks/useCartState';

export const CartContext = React.createContext();

export const CartContextProvider = ({
  initialFunds = [],
  initialTotalAmount,
  initialPercentMode = true,
  children
}) => {
  const state = useCartState({
    initialFunds,
    initialTotalAmount,
    initialPercentMode
  });

  return <CartContext.Provider value={state}>{children}</CartContext.Provider>;
};

CartContextProvider.propTypes = {
  initialFunds: PropTypes.arrayOf(
    PropTypes.shape({
      ticker: PropTypes.string,
      name: PropTypes.string,
      percent: PropTypes.number,
      amount: PropTypes.number
    })
  ),
  initialTotalAmount: PropTypes.number.isRequired,
  initialPercentMode: PropTypes.bool
};
